// extracted by mini-css-extract-plugin
module.exports = {"item":"CompanyCardListWithJob_item__2tF92","sending":"CompanyCardListWithJob_sending__Qaldx"};